/* eslint-disable sort-keys-fix/sort-keys-fix */

export const QBRFIRSTREPORTS = {
    AppClassificationScore: {
        key: `qbrQBRFirstAppClassificationScore`,
        name: 'Reports.qbr.checkbox.QBRFirst.subOption.AppClassificationScore'
    },
    ManagedAppScore: {
        key: `qbrQBRFirstManagedAppScore`,
        name: 'Reports.qbr.checkbox.QBRFirst.subOption.ManagedAppScore'
    },
    ShadowITScore: {
        key: `qbrQBRFirstShadowITScore`,
        name: 'Reports.qbr.checkbox.QBRFirst.subOption.ShadowITScore'
    },
    UnapprovedAppScore: {
        key: `qbrQBRFirstUnapprovedAppScore`,
        name: 'Reports.qbr.checkbox.QBRFirst.subOption.UnapprovedAppScore'
    },
    AppOverlapScore: {
        key: `qbrQBRFirstAppOverlapScore`,
        name: 'Reports.qbr.checkbox.QBRFirst.subOption.AppOverlapScore'
    },
    SaaSSophisticationScore: {
        key: `qbrQBRFirstSaaSSophisticationScore`,
        name: 'Reports.qbr.checkbox.QBRFirst.subOption.SaaSSophisticationScore'
    }
};
